/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FleetYards.net API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  PushSubscription,
  PushSubscriptionInput,
  PushSubscriptionsList,
  SchemaValidationErrorResponse,
  StandardError,
  ValidationError
} from '../../models';

import { axiosClient } from '../../../axiosClient.ts';
import type { ErrorType } from '../../../axiosClient.ts';




/**
 * @summary Push subscriptions
 */
export const pushSubscriptions = (

 signal?: AbortSignal
) => {


      return axiosClient<PushSubscriptionsList>(
      {url: `/push-subscriptions`, method: 'GET', signal
    },
      );
    }




export const getPushSubscriptionsQueryKey = () => {
    return [
    'push-subscriptions'
    ] as const;
    }


export const getPushSubscriptionsQueryOptions = <TData = Awaited<ReturnType<typeof pushSubscriptions>>, TError = ErrorType<StandardError>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pushSubscriptions>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getPushSubscriptionsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof pushSubscriptions>>> = ({ signal }) => pushSubscriptions(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof pushSubscriptions>>, TError, TData>
}

export type PushSubscriptionsQueryResult = NonNullable<Awaited<ReturnType<typeof pushSubscriptions>>>
export type PushSubscriptionsQueryError = ErrorType<StandardError>


/**
 * @summary Push subscriptions
 */

export function usePushSubscriptions<TData = Awaited<ReturnType<typeof pushSubscriptions>>, TError = ErrorType<StandardError>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pushSubscriptions>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPushSubscriptionsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Subscribe this browser to push notifications
 */
export const createPushSubscription = (
    pushSubscriptionInput: MaybeRefOrGetter<PushSubscriptionInput>,
 signal?: AbortSignal
) => {
      pushSubscriptionInput = toValue(pushSubscriptionInput);

      return axiosClient<PushSubscription>(
      {url: `/push-subscriptions`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: pushSubscriptionInput, signal
    },
      );
    }




export const getCreatePushSubscriptionMutationKey = () => ['createPushSubscription'] as const;

export const getCreatePushSubscriptionMutationOptions = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPushSubscription>>, TError,CreatePushSubscriptionMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createPushSubscription>>, TError,CreatePushSubscriptionMutationVariables, TContext> => {

const mutationKey = getCreatePushSubscriptionMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createPushSubscription>>, CreatePushSubscriptionMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createPushSubscription(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreatePushSubscriptionMutationResult = NonNullable<Awaited<ReturnType<typeof createPushSubscription>>>
    export type CreatePushSubscriptionMutationBody = PushSubscriptionInput
    export type CreatePushSubscriptionMutationError = ErrorType<ValidationError | StandardError>
    export type CreatePushSubscriptionMutationVariables = {data: PushSubscriptionInput}

    /**
 * @summary Subscribe this browser to push notifications
 */
export const useCreatePushSubscription = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPushSubscription>>, TError,CreatePushSubscriptionMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createPushSubscription>>,
        TError,
        CreatePushSubscriptionMutationVariables,
        TContext
      > => {
      return useMutation(getCreatePushSubscriptionMutationOptions(options), queryClient);
    }
    /**
 * @summary Unsubscribe a browser from push notifications
 */
export const destroyPushSubscription = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<void>(
      {url: `/push-subscriptions/${id}`, method: 'DELETE', signal
    },
      );
    }




export const getDestroyPushSubscriptionMutationKey = () => ['destroyPushSubscription'] as const;

export const getDestroyPushSubscriptionMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyPushSubscription>>, TError,DestroyPushSubscriptionMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof destroyPushSubscription>>, TError,DestroyPushSubscriptionMutationVariables, TContext> => {

const mutationKey = getDestroyPushSubscriptionMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof destroyPushSubscription>>, DestroyPushSubscriptionMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  destroyPushSubscription(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DestroyPushSubscriptionMutationResult = NonNullable<Awaited<ReturnType<typeof destroyPushSubscription>>>

    export type DestroyPushSubscriptionMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type DestroyPushSubscriptionMutationVariables = {id: string}

    /**
 * @summary Unsubscribe a browser from push notifications
 */
export const useDestroyPushSubscription = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyPushSubscription>>, TError,DestroyPushSubscriptionMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof destroyPushSubscription>>,
        TError,
        DestroyPushSubscriptionMutationVariables,
        TContext
      > => {
      return useMutation(getDestroyPushSubscriptionMutationOptions(options), queryClient);
    }
    /**
 * @summary Mark this browser's push subscription as still in use
 */
export const touchPushSubscription = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<PushSubscription>(
      {url: `/push-subscriptions/${id}/touch`, method: 'PUT', signal
    },
      );
    }




export const getTouchPushSubscriptionMutationKey = () => ['touchPushSubscription'] as const;

export const getTouchPushSubscriptionMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof touchPushSubscription>>, TError,TouchPushSubscriptionMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof touchPushSubscription>>, TError,TouchPushSubscriptionMutationVariables, TContext> => {

const mutationKey = getTouchPushSubscriptionMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof touchPushSubscription>>, TouchPushSubscriptionMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  touchPushSubscription(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type TouchPushSubscriptionMutationResult = NonNullable<Awaited<ReturnType<typeof touchPushSubscription>>>

    export type TouchPushSubscriptionMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type TouchPushSubscriptionMutationVariables = {id: string}

    /**
 * @summary Mark this browser's push subscription as still in use
 */
export const useTouchPushSubscription = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof touchPushSubscription>>, TError,TouchPushSubscriptionMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof touchPushSubscription>>,
        TError,
        TouchPushSubscriptionMutationVariables,
        TContext
      > => {
      return useMutation(getTouchPushSubscriptionMutationOptions(options), queryClient);
    }
